import { z } from 'zod'

import type { RequestService } from '../request'

export function hocuspocusApiFactory(requestService: RequestService) {
  async function fetchDoc(name: string) {
    return await requestService.request({
      url: `hocuspocus/doc/${name}`,
      method: 'get',
      schema: z.any(),
    })
  }

  async function fetchReference(name: string) {
    return await requestService.request({
      url: `hocuspocus/doc/${name}`,
      method: 'get',
      schema: z.any(),
    })
  }

  async function fetchReferences(yjsRefs: string[]) {
    return await requestService.request({
      url: 'hocuspocus/doc/batch',
      method: 'post',
      data: {
        items: yjsRefs.map((ref) => `reference-${ref}`),
        parser: 'reference',
      },
      schema: z.record(z.string(), z.string().nullable()),
    })
  }

  return {
    fetchDoc,
    fetchReference,
    fetchReferences,
  }
}
